jQuery(function($) {
   	$(document).foundation();
});
